import Image from 'next/image'
import Link from 'next/link'
import { FaAngleRight } from 'react-icons/fa'

/**
 * Article header for the aircon guides (/sg/aircon-servicing-singapore/[slug]):
 * the post's own H1 and featured image, plus one link to the service the
 * guide's topic cluster is about (utils/aircon-guide-clusters).
 *
 * Deliberately not the service-page booking hero. That put a generic video
 * and a general-servicing price card above every guide, so on mobile the
 * article started about 1.5 screens down - main content below a commercial
 * block, on informational pages. Booking now follows the article
 * (AirconGuideBooking) where its prices fit the topic.
 *
 * No excerpt lead: WordPress auto-excerpts are the post's first ~55 words,
 * so it would print the opening paragraph twice.
 */
export const AirconGuideHero = ({ title, heroImage, service }) => (
    <header className='max-w-5xl mx-auto px-4 pt-2 pb-6 space-y-4'>
        <h1 className='text-2xl sm:text-4xl font-bold text-gray-900 leading-tight'>{title}</h1>
        {service &&
            <Link href={service.href} prefetch={false}
                className='inline-flex items-center gap-1 text-sm font-semibold text-orange-600 hover:underline'>
                {service.label}
                <FaAngleRight aria-hidden="true" />
            </Link>
        }
        {heroImage &&
            <div className='relative w-full aspect-video sm:aspect-[2/1] overflow-hidden rounded-xl bg-gray-100'>
                <Image
                    src={heroImage}
                    fill
                    className='object-cover'
                    alt={title}
                    priority
                    sizes="(min-width: 1024px) 1024px, 100vw"
                />
            </div>
        }
    </header>
)
